<i-dragndrop [droppableAreas]="droppableAreas()" (onareadrop)="onFileDropped($event)">
    <div class="documents-n-files" [class.documents-collapsed]="documentsCollapsed()"
        [class.files-collapsed]="filesCollapsed()">
        <div class="documents-n-files__documents card">
            <h4 class="d-flex align-items-center gap-2">
                <i class="bi bi-chevron-down collapsible-chevron" [class.open]="!documentsCollapsed()"
                    (click)="toggleDocuments()"></i>
                Documents {{documents().length ? "(" + documents().length + ")" : ''}}
            </h4>
            <div class="collapsible documents-n-files__documents__collapsible" [class.collapsed]="documentsCollapsed()">
                <div class="collapsible__inner">
                    @if(!fetchingDocumentModels()) {
                    <div class="documents-n-files__documents__header">
                        <label class="d-flex align-items-center gap-2 cursor-pointer">
                            <p-checkbox [binary]="true" [ngModel]="allDocumentsSelected()"
                                (ngModelChange)="toggleAllDocuments()"></p-checkbox>
                            <span class="small text-secondary">Tout sélectionner</span>
                        </label>
                    </div>
                    @if(canGenerateMassively) {
                    <div class="documents-n-files__documents__actions fade-in">
                        <span class="small fw-semibold">{{ selectedDocumentsCount() }} document(s) sélectionné(s)</span>
                        <i-button [styleClass]="'btn-primary'" [text]="massiveGenerationText"
                            [disabled]="!canGenerateMassively"></i-button>
                    </div>
                    }
                    <div class="documents-n-files__documents__list">
                        @for(document of documents(); track document.id; let index = $index; let last = $last) {
                        <div class="documents-n-files__documents__document" [class.mb-3]="!last"
                            [class.selected]="document.shouldGenerate"
                            [class.viewing]="isDocumentCurrentlyViewed(document)"
                            [class.generation-error]="hasGenerationError(document)">
                            <div class="d-flex flex-column">
                                <span class="fw-bold">{{ document.description }}</span>
                                <span class="italic fw-light">{{ getGeneratedMessage(document) }}</span>
                                @if(hasGenerationError(document)) {
                                <span class="generation-error-badge" [pTooltip]="getGenerationErrorLabel(document)"
                                    tooltipPosition="top">
                                    <i class="bi bi-exclamation-triangle-fill"></i>
                                    {{ getGenerationErrorLabel(document) }}

                                </span>
                                }
                            </div>
                            <span>
                                @if(document.version) {
                                <idel-basic-badge [value]="getDocumentNbrOfVersions(document)"
                                    [variant]="'primary'"></idel-basic-badge>
                                }
                            </span>
                            <span class="d-flex align-content-center gap-2 flex-wrap">
                                <idel-rounded-button
                                    [icon]="isDocumentGenerated(document) ? 'bi bi-check-all' : icons.generate"
                                    [severity]="'success'" [hoverable]="!isDocumentGenerated(document)"
                                    [tooltip]="isDocumentGenerated(document) ? 'Document généré' : 'Générer le document'"
                                    [loading]="document.generating" [disabled]="!document.rights.canGenerateModele"
                                    (click)="generateDocument(document)"></idel-rounded-button>

                                <idel-rounded-button
                                    [icon]="isDocumentPreviewGenerated(document) ? 'bi bi-check' : icons.preview"
                                    [hoverable]="document.rights.canSubmitModelePreviewRequest" [severity]="'primary'"
                                    [tooltip]="isDocumentPreviewGenerated(document) ? 'Aperçu généré': 'Générer l\'aperçu'"
                                    [loading]="document.previewGenerating"
                                    [disabled]="!document.rights.canSubmitModelePreviewRequest"
                                    (click)="generateDocumentPreview(document)"></idel-rounded-button>
                                @if(!hasGenerationError(document)) {

                                @if(target().scope === 'point') {
                                <idel-rounded-button [icon]="icons.compliantExtract" [severity]="'primary'"
                                    [tooltip]="!canGenerateCompliantExtract(document) ? 'L\'extrait conforme ne peut pas être généré' : 'Générer l\'extrait conforme'"
                                    [disabled]="!canGenerateCompliantExtract(document)"
                                    [loading]="document?.generatingCompliantExtract"
                                    (click)="generateCompliantExtract(document)"></idel-rounded-button>
                                }
                                <idel-rounded-button [icon]="icons.update" [severity]="'warning'"
                                    [tooltip]="!canUpdateDocument(document) ? 'Générez le document pour pouvoir le modifier' : 'Modifier le document'"
                                    [disabled]="!canUpdateDocument(document) || isDocumentBeingGenerated(document)"
                                    (click)="updateDocument(document)"></idel-rounded-button>

                                @if(canSignDocument(document)) {
                                <idel-rounded-button [icon]="icons.sign" [severity]="'primary'"
                                    [disabled]="!canSignDocument(document)"
                                    [pTooltip]="!canSignDocument(document) ? 'Vous ne pouvez pas signer ce document' : 'Signer ce document'"
                                    (click)="signDocument(document)"></idel-rounded-button>
                                }

                                <idel-rounded-button [icon]="icons.download" [outlined]="true"
                                    [disabled]="!canDownloadDocument(document)"
                                    [tooltip]="!canDownloadDocument(document) ? 'Générez d\'abord l\'aperçu ou le document' : 'Télécharger ce document'"
                                    (click)="downloadDocument(document)"></idel-rounded-button>

                                <idel-rounded-button [icon]="icons.see"
                                    [outlined]="!isDocumentCurrentlyViewed(document)"
                                    [disabled]="!canSeeDocument(document)"
                                    [tooltip]="!canSeeDocument(document) ? 'Générez d\'abord l\'aperçu ou le document' : 'Voir ce document'"
                                    (click)="seeDocument(document)"
                                    [severity]="isDocumentCurrentlyViewed(document) ? 'primary' : undefined"></idel-rounded-button>
                                }

                            </span>
                        </div>
                        }@empty {
                        <idel-empty-result-placeholder [emptyMessage]="'Aucun document pour le moment'"
                            [options]="emptyDocumentsOptions"></idel-empty-result-placeholder>
                        }
                    </div>
                    }@else {
                    <div>
                        <i-loader></i-loader>
                    </div>
                    }
                </div>
            </div>
        </div>
        <div class="documents-n-files__files card">
            <h4 class="d-flex flex-row justify-content-between align-items-center">
                <span class="d-flex align-items-center gap-2">
                    <i class="bi bi-chevron-down collapsible-chevron" [class.open]="!filesCollapsed()"
                        (click)="toggleFiles()"></i>
                    Fichiers {{files().length ? "(" + files().length + ")" : ''}}
                </span>
                <span class="d-flex align-items-center gap-2">
                    <i-button [styleClass]="'blue'" [text]="'Import annexe'" [icon]="'bi bi-plus-lg'"
                        [iconPosition]="'left'" (click)="triggerFileInput('annexe')"></i-button>
                    <i-button [styleClass]="'blue'" [text]="'Import associé'" [icon]="'bi bi-plus-lg'"
                        [iconPosition]="'left'" (click)="triggerFileInput('associe')"></i-button>
                </span>
            </h4>
            <input #annexeFileInput type="file" multiple hidden (change)="onFileInputChange($event, true)">
            <input #associeFileInput type="file" multiple hidden (change)="onFileInputChange($event, false)">
            <div class="collapsible documents-n-files__files__collapsible" [class.collapsed]="filesCollapsed()">
                <div class="collapsible__inner">
                    @if(!fetchingFiles()) {
                    <div class="documents-n-files__files__header">
                        <label class="d-flex align-items-center gap-2 cursor-pointer">
                            <p-checkbox [binary]="true" [ngModel]="allFilesSelected()"
                                (ngModelChange)="toggleAllFiles()"></p-checkbox>
                            <span class="small text-secondary">Tout sélectionner</span>
                        </label>
                    </div>
                    @if(someFilesSelected()) {
                    <div class="documents-n-files__files__actions fade-in">
                        <span class="small fw-semibold">{{ selectedFileIds().size }} fichier(s)</span>
                        <span class="d-flex align-items-center gap-2">
                            <span class="d-flex align-items-center gap-1">
                                <span class="small text-secondary">Mandataires</span>
                                <idel-rounded-button [icon]="'bi bi-eye-fill'" [severity]="'success'" [outlined]="true"
                                    [tooltip]="'Rendre visible pour les mandataires'"
                                    (click)="setFilesVisibility('visibleDelibeWeb', true)"></idel-rounded-button>
                                <idel-rounded-button [icon]="'bi bi-eye-slash-fill'" [severity]="'danger'"
                                    [outlined]="true" [tooltip]="'Rendre non visible pour les mandataires'"
                                    (click)="setFilesVisibility('visibleDelibeWeb', false)"></idel-rounded-button>
                            </span>
                            <span class="documents-n-files__files__actions__sep"></span>
                            <span class="d-flex align-items-center gap-1">
                                <span class="small text-secondary">Citoyens</span>
                                <idel-rounded-button [icon]="'bi bi-eye-fill'" [severity]="'success'" [outlined]="true"
                                    [tooltip]="'Rendre visible pour les citoyens'"
                                    (click)="setFilesVisibility('visibleDelibeWebCitoyen', true)"></idel-rounded-button>
                                <idel-rounded-button [icon]="'bi bi-eye-slash-fill'" [severity]="'danger'"
                                    [outlined]="true" [tooltip]="'Rendre non visible pour les citoyens'"
                                    (click)="setFilesVisibility('visibleDelibeWebCitoyen', false)"></idel-rounded-button>
                            </span>
                            <span class="documents-n-files__files__actions__sep"></span>
                            <idel-rounded-button [icon]="'bi bi-trash-fill'" [severity]="'danger'"
                                [loading]="deletingFiles()" [tooltip]="'Supprimer les fichiers sélectionnés'"
                                (click)="deleteSelectedFiles()"></idel-rounded-button>
                        </span>
                    </div>
                    }
                    <div class="documents-n-files__files__list">
                        @for(file of files(); track file.id; let last = $last) {
                        <div class="documents-n-files__files__file" [class.mb-3]="!last"
                            [class.viewing]="isFileCurrentlyViewed(file)"
                            [class.selected]="selectedFileIds().has(file.id)">
                            <p-checkbox [binary]="true" [ngModel]="selectedFileIds().has(file.id)"
                                (ngModelChange)="toggleFileSelection(file)"></p-checkbox>
                            <div class="d-flex align-items-center gap-2">
                                <i [class]="getFileIcon(file.extension)"
                                    [ngClass]="'file-icon ' + getFileIconColorClass(file.extension)"
                                    [pTooltip]="getFileTypeLabel(file.extension)" tooltipPosition="top"></i>
                                <div class="d-flex flex-column">
                                    <span class="fw-bold">{{ file.description }}</span>
                                    <!--prettier-ignore-->
                                    <span class="italic fw-light small">{{getFileUploadDate(file)}}</span>
                                </div>
                            </div>
                            @if(file.annexe) {
                            <idel-basic-badge [value]="file.annexeNumero ? 'Annexe ' + file.annexeNumero : 'Annexe'"
                                [variant]="'amber'"></idel-basic-badge>
                            } @else {
                            <idel-basic-badge [value]="'Associé'"></idel-basic-badge>
                            }
                            <span class="d-flex align-items-center gap-2">
                                <img src="assets/img/iDélibéMandataires.svg" alt="Logo iDélibé Mandataire"
                                    [class.disabled]="!file.visibleDelibeWeb" class="app-icons cursor-pointer"
                                    [pTooltip]="file.visibleDelibeWeb ? 'Visible pour les mandataires (cliquer pour inverser)' : 'Non visible pour les mandataires (cliquer pour inverser)'"
                                    (click)="setFileVisibility({file: file, field: 'visibleDelibeWeb', visible: !(file.visibleDelibeWeb)})">
                                <img src="assets/img/iDelibeCitoyenLogo.svg" alt="Logo iDélibé Citoyen"
                                    class="app-icons cursor-pointer"
                                    [pTooltip]="file.visibleDelibeWebCitoyen ? 'Visible pour les citoyens (cliquer pour inverser)' : 'Non visible pour les citoyens (cliquer pour inverser)'"
                                    [class.disabled]="!file.visibleDelibeWebCitoyen"
                                    (click)="setFileVisibility({file: file, field: 'visibleDelibeWebCitoyen', visible: !(file.visibleDelibeWebCitoyen)})">
                            </span>
                            <span class="d-flex align-content-center gap-2">
                                <idel-rounded-button [icon]="icons.update" [severity]="'warning'"
                                    [tooltip]="'Modifier ce fichier'"
                                    (click)="openEditDialog(file)"></idel-rounded-button>
                                <idel-rounded-button [icon]="icons.download" [outlined]="true"
                                    [tooltip]="'Télécharger ce fichier'"
                                    (click)="downloadFile(file)"></idel-rounded-button>
                                <idel-rounded-button [icon]="icons.see" [outlined]="!isFileCurrentlyViewed(file)"
                                    [disabled]="!canPreviewFile(file)"
                                    [tooltip]="canPreviewFile(file) ? 'Voir ce fichier' : 'Aperçu disponible uniquement pour les PDF'"
                                    (click)="seeFile(file)"
                                    [severity]="isFileCurrentlyViewed(file) ? 'primary' : undefined"></idel-rounded-button>
                            </span>
                        </div>
                        }@empty {
                        <idel-empty-result-placeholder [emptyMessage]="'Aucun fichier pour le moment'"
                            [options]="emptyFilesOptions"></idel-empty-result-placeholder>
                        }
                    </div>
                    }@else {
                    <div>
                        <i-loader></i-loader>
                    </div>
                    }
                </div>
            </div>
        </div>

        <div class="documents-n-files__editor card">
            @if(!currentDocumentToDisplay().document && !currentFileToDisplay()) {
            <div class="documents-n-files__editor__placeholder">
                <img src="assets/img/ai/meeting-documents/placeholder_v2.png" alt="Placeholder">
                <span class="small text-secondary">Sélectionner un document à visualiser ou à modifier</span>
            </div>
            }@else {
            @if(currentFileForViewer() && (currentFileToDisplay() || currentDocumentToDisplay().mode === 'pdf'))
            {
            <div class="h-100 w-100">
                <i-viewer [file]="currentFileForViewer()" [viewerConfig]="pdfViewerConfig"
                    styleClass="h-100 d-block w-100"></i-viewer>
            </div>
            }
            <!--Display none is a DOM trick to hide the element but still let the richedit to init correctly-->
            <div class="h-100 w-100"
                [class.d-none]="!(currentDocumentToDisplay().document && currentDocumentToDisplay().mode !== 'pdf')">
                <div class="w-100 d-flex justify-content-end mb-1">
                    <i-button [styleClass]="'blue'" [text]="'Sauver'" (click)="uploadUpdatedDocument()"
                        [loading]="savingRtf()" [disabled]="savingRtf()"></i-button>
                </div>
                <i-richedit [options]="{ width: '100%', height: '100%' }" [exportable]="false"
                    (onSave)="uploadUpdatedDocument()">
                </i-richedit>
            </div>
            }
        </div>

    </div>
</i-dragndrop>

@if(fileEditForm && fileBeingEdited()) {
<p-dialog [visible]="isUpdateFileDialogOpen()" (visibleChange)="closeEditDialog()" [appendTo]="'body'"
    header="Modification de fichier" [style]="{width: '600px'}">
    <form [formGroup]="fileEditForm" class="file-edit-dialog__form">

        <div class="file-edit-dialog__row">
            <div class="file-edit-dialog__field file-edit-dialog__field--grow">
                <label class="input-label">Description</label>
                <input pInputText formControlName="description" class="w-100" />
            </div>
            <div class="file-edit-dialog__field file-edit-dialog__field--order">
                <label class="input-label">Ordre d'affichage</label>
                <p-inputNumber formControlName="order" [min]="1" [showButtons]="false"
                    styleClass="w-100"></p-inputNumber>
            </div>
        </div>

        <div class="file-edit-dialog__field">
            <label class="input-label">Type de fichier</label>
            <span class="file-edit-dialog__readonly">
                <i [class]="getFileIcon(fileBeingEdited().extension)"
                    [ngClass]="'file-icon ' + getFileIconColorClass(fileBeingEdited().extension)"></i>
                {{ getFileTypeLabel(fileBeingEdited().extension) }}
                <span class="text-secondary small">.{{ fileBeingEdited().extension }}</span>
            </span>
        </div>

        <div class="file-edit-dialog__row">
            <div class="file-edit-dialog__field">
                <label class="input-label">Annexe</label>
                <p-inputSwitch formControlName="asAttachement"></p-inputSwitch>
            </div>
            <div class="file-edit-dialog__field">
                <label class="input-label">Numéro d'annexe</label>
                <p-inputNumber formControlName="attachementNumber" [min]="1" [showButtons]="false"
                    styleClass="w-100"></p-inputNumber>
            </div>
        </div>

        <div class="file-edit-dialog__field">
            <label class="input-label">Visibilité</label>
            <div class="file-edit-dialog__visibility">
                <div class="file-edit-dialog__visibility__row">
                    <img src="assets/img/iDélibéMandataires.svg" alt="Mandataires" class="file-edit-dialog__app-icon">
                    <span>Mandataires</span>
                    <p-inputSwitch formControlName="visibleForRepresentatives"></p-inputSwitch>
                </div>
                <div class="file-edit-dialog__visibility__row">
                    <img src="assets/img/iDelibeCitoyenLogo.svg" alt="Citoyens" class="file-edit-dialog__app-icon">
                    <span>Citoyens</span>
                    <p-inputSwitch formControlName="visibleForCitizens"></p-inputSwitch>
                </div>
            </div>
        </div>

    </form>
    <div class="file-edit-dialog__footer mt-3 d-flex justify-content-end w-100">
        <i-button [styleClass]="'green'" [text]="'Confirmer'" [icon]="'bi bi-check-fill'" [iconPosition]="'left'"
            (click)="confirmEditFile()" [loading]="updatingFile()" [disabled]="updatingFile()"></i-button>
    </div>
</p-dialog>
}